export enum UserActionHistory {
    SELECTED_HOME_TABS_INDEX = 'selectedHomeTabsIndex',
    HOME_TABS_VIEW = 'homeTabsView',
    HOME_TAB_OVERVIEW = 'homeTabsOverview',
    HOME_THIRD_COLUMN_TOGGLE = 'homeThirdColumnToggle',
    SELECTED_HOME_ACTIONS_TABS_INDEX = 'selectedHomeActionsTabsIndex',
    SELECTED_HOME_ACTIONS_TABS_RESOURCE_ID = 'selectedHomeActionsTabsResourceId',
    SELECTED_HOME_TABS_RESOURCE_ID = 'selectedHomeTabsResourceId',
    SELECTED_HOME_TABS_RESOURCE_OCCASION_ID = 'selectedHomeTabsResourceOccasionId',
}
